import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
const testimonials = [{
  id: 1,
  name: 'Selina Agwu',
  text: 'My husband and I had lunch at your restaurant… your menu is classic African executed excellently.'
}, {
  id: 2,
  name: 'Ada Williams',
  text: 'Everyone had a wonderful time. As expected, the food was delicious.'
}, {
  id: 3,
  name: 'James Orka',
  text: 'Everything was so yummy… I will be back soon.'
}];
export function Testimonials() {
  return <section className="py-20 bg-light relative overflow-hidden" data-id="element-203">
      {/* Subtle African-inspired geometric pattern background */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'repeating-linear-gradient(45deg, #D4A017 25%, transparent 25%, transparent 75%, #D4A017 75%, #D4A017), repeating-linear-gradient(45deg, #D4A017 25%, transparent 25%, transparent 75%, #D4A017 75%, #D4A017)',
      backgroundPosition: '0 0, 20px 20px',
      backgroundSize: '40px 40px'
    }} data-id="element-204" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-205">
        <div className="text-center mb-16" data-id="element-206">
          <h2 className="font-heading text-4xl md:text-5xl text-charcoal uppercase tracking-wide mb-4" data-id="element-207">
            What Our <span className="text-amber" data-id="element-208">Customers Say</span>
          </h2>
          <div className="w-24 h-1 bg-victory-red mx-auto rounded-full" data-id="element-209" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-210">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-cream rounded-3xl p-8 shadow-xl border border-amber/10 relative" data-id="element-211">
              <QuoteIcon className="absolute top-6 right-6 w-12 h-12 text-amber/20" data-id="element-212" />
              <div className="flex space-x-1 mb-6" data-id="element-213">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-amber fill-amber" data-id="element-214" />)}
              </div>
              <p className="font-body text-charcoal/80 text-lg italic mb-8 relative z-10 leading-relaxed" data-id="element-215">
                "{testimonial.text}"
              </p>
              <div className="flex items-center space-x-4 border-t border-charcoal/10 pt-4" data-id="element-216">
                <div className="w-12 h-12 bg-charcoal rounded-full flex items-center justify-center text-white font-heading text-xl" data-id="element-217">
                  {testimonial.name.charAt(0)}
                </div>
                <h4 className="font-heading text-xl text-charcoal uppercase tracking-wide" data-id="element-218">
                  {testimonial.name}
                </h4>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}